import { inject, Injectable } from '@angular/core';
import { MobileNavItemLinks } from '@com-delta-idp/mnx-sitewide-header-ui';
import { HeaderFooterMachCoreContentService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BehaviorSubject } from 'rxjs';
import { WidgetNavigationLinksAdapterService } from '../../adapters/widget-navigation-links/widget-navigation-links-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class WidgetNavigationLinksFacadeService {
  adapter = inject(WidgetNavigationLinksAdapterService);
  headerFooterContent = inject(HeaderFooterMachCoreContentService);
  mobileNavigationLinksDetails$ = new BehaviorSubject<MobileNavItemLinks>(
    {} as MobileNavItemLinks
  );

  init(): void {
    this.headerFooterContent
      .getHeaderFooterMachCoreContent$()
      .subscribe((content) => {
        this.mobileNavigationLinksDetails$.next(
          this.adapter.getContent(content)
        );
      });
  }
}
